// extracted by mini-css-extract-plugin
module.exports = {"contact":"bg_fr","contact__wrapper":"bg_fs","error__select":"bg_ft","error__input":"bg_fv"};